/**
 * Simulateur de revenus.
 *
 * Formules, reprises telles quelles de la maquette validée :
 *   boissons / mois      = passage × captage / 100 × 30
 *   CA machine / an      = boissons / mois × prix × 12
 *   commission / an      = CA × taux de commission / 100
 *   adhérents conservés  = adhérents × gain de rétention / 100   (arrondi)
 *   fidélisation / an    = adhérents conservés × abonnement × mois gagnés
 *
 * Le total additionne commission et fidélisation. La barre montre leur part
 * respective ; quand le total est nul, on retombe sur 1 pour éviter la division
 * par zéro (la barre reste alors vide, ce qui est le rendu attendu).
 */
(() => {
  /** Formatages d'affichage, en convention française. */
  const FORMATS = {
    jour: (v) => `${v.toLocaleString('fr-FR')} / jour`,
    pourcent_virgule: (v) => `${String(v).replace('.', ',')} %`,
    pourcent: (v) => `${v} %`,
    nombre: (v) => v.toLocaleString('fr-FR'),
    euro: (v) => `${v} €`,
    euro_centimes: (v) => `${v.toFixed(2).replace('.', ',')} €`,
    point: (v) => `${String(v).replace('.', ',')} pt`,
    mois: (v) => `${v} mois`,
  };

  const euros = (n) => `${Math.round(n).toLocaleString('fr-FR')} €`;

  document.querySelectorAll('[data-oyw-simulateur]').forEach((section) => {
    const curseurs = [...section.querySelectorAll('[data-sim]')];
    if (curseurs.length === 0) return;

    const cible = (nom) => section.querySelector(`[data-sim-${nom}]`);

    const sorties = {
      total: cible('total'),
      totalMois: cible('total-mois'),
      com: cible('com'),
      ret: cible('ret'),
      ca: cible('ca'),
      boissons: cible('boissons'),
      conserves: cible('conserves'),
      barreCom: cible('barre-com'),
      barreRet: cible('barre-ret'),
    };

    const calculer = () => {
      // Valeurs courantes des curseurs, indexées par clé.
      const v = {};
      curseurs.forEach((curseur) => {
        v[curseur.dataset.sim] = Number(curseur.value);
      });

      const boissonsMois = (v.pass * v.capt) / 100 * 30;
      const caAn = boissonsMois * v.prix * 12;
      const commissionAn = (caAn * v.com) / 100;
      const conserves = Math.round((v.adh * v.ret) / 100);
      const fidelisationAn = conserves * v.abo * v.duree;
      const total = commissionAn + fidelisationAn;
      const base = total || 1;

      // Valeur affichée à côté de chaque curseur.
      curseurs.forEach((curseur) => {
        const affichage = section.querySelector(`[data-sim-affichage="${curseur.dataset.sim}"]`);
        const format = FORMATS[curseur.dataset.format];
        if (affichage && format) affichage.textContent = format(Number(curseur.value));
      });

      if (sorties.total) sorties.total.textContent = euros(total);
      if (sorties.totalMois) sorties.totalMois.textContent = euros(total / 12);
      if (sorties.com) sorties.com.textContent = euros(commissionAn);
      if (sorties.ret) sorties.ret.textContent = euros(fidelisationAn);
      if (sorties.ca) sorties.ca.textContent = euros(caAn);
      if (sorties.boissons) sorties.boissons.textContent = Math.round(boissonsMois).toLocaleString('fr-FR');
      if (sorties.conserves) sorties.conserves.textContent = conserves.toLocaleString('fr-FR');
      if (sorties.barreCom) sorties.barreCom.style.width = `${(commissionAn / base) * 100}%`;
      if (sorties.barreRet) sorties.barreRet.style.width = `${(fidelisationAn / base) * 100}%`;
    };

    curseurs.forEach((curseur) => curseur.addEventListener('input', calculer));
    calculer();
  });
})();
